
  export default {
    props: {
      tooltip: { type: String, default: null }
    },
    computed: {
      tooltipOptions () {
        if (!this.tooltip) {
          return null;
        }
        let opts = { classes: 'listItemTooltip', content: this.tooltip };
        if (!this.$store.getters['utils/isTablet']) {
          opts.trigger = 'click';
        }
        return opts;
      }
    }
  };
